import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { CobaltIcon } from "da-design-system";
import CAIHButtonLink from "../CAIHButtonLink";

export default function ConsentLoginMobileInformations({ hash }) {
  const VALIDATION_STEPS = [
    {
      id: 1,
      label: "Cliquez sur le bouton ci-dessous pour exercer vos droits",
    },
    { id: 2, label: "Indiquez vos préférences" },
    {
      id: 3,
      label:
        "Validez pour enregistrer vos choix. Vous pourrez les modifier par la suite",
    },
  ];

  return (
    <Grid
      container
      justifyContent="center"
      sx={theme => ({
        backgroundColor: "cobalt.white",
        boxShadow: theme.shadows[2],
        borderRadius: "4px",
      })}
    >
      <Grid
        item
        sx={theme => ({
          backgroundColor: "cobalt.bleuDigital05",
          [theme.breakpoints.down("md")]: {
            backgroundColor: "cobalt.white",
          },
        })}
        xs={12}
        p={6}
      >
        <Typography variant="h1" sx={{ pb: 4 }}>
          Traitement de vos données personnelles
        </Typography>
        <Typography variant="body1">
          Le CHU de Toulouse a fait confiance à Docaposte pour vous informer du 
          traitement des données personnelles (médicales et administratives) à des 
          fins de recherche en santé et d’amélioration du soin.
        </Typography>
      </Grid>
      <Grid
        item
        container
        flexDirection="row"
        xs={12}
        justifyContent="space-between"
        component="ul"
      >
        {VALIDATION_STEPS.map(step => (
          <Grid
            item
            component="ol"
            xs={12}
            md={3.5}
            key={step.id}
            display="flex"
            gap={4}
            sx={{
              p: 4,
              m: 2,
            }}
          >
            <Typography variant="h3" component="p">
              {step.id}
            </Typography>
            <Typography color="cobalt.lynch" component="p">
              {step.label}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Grid item container xs={12} p={6} justifyContent="flex-end">
        <CAIHButtonLink href={`/consent${hash}`} label="Exprimer mes droits">
          <CobaltIcon
            name="arrow-right"
            sx={{ fontSize: theme => theme.spacing(2) }}
          />
        </CAIHButtonLink>
      </Grid>
    </Grid>
  );
}

ConsentLoginMobileInformations.propTypes = {
  hash: PropTypes.string.isRequired,
};
